/* =========================================================================
   Lozea — real Shopify Cart AJAX API wiring (no framework).
   Add to cart, quantity change, remove — all hit the real Storefront Cart
   endpoints (/cart/add.js, /cart/change.js, /cart.js) and re-render the
   cart drawer using Shopify's Section Rendering API (`sections` param), so
   the drawer markup always comes from sections/cart-drawer.liquid — never a
   duplicated JS template.
   ========================================================================= */
(function () {
  'use strict';

  var cfg = window.LZ && window.LZ.routes ? window.LZ.routes : null;
  var SECTION_ID = (window.LZ && window.LZ.cartSectionId) || 'cart-drawer';
  if (!cfg) return;

  var drawer = null;
  var lastFocused = null;

  function getDrawer() {
    drawer = document.querySelector('[data-lz-cart-drawer]');
    return drawer;
  }
  getDrawer();

  function announce(message) {
    var status = drawer && drawer.querySelector('[data-lz-cart-status]');
    if (status) status.textContent = message;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-lz-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('lz-scroll-lock');
    var close = drawer.querySelector('[data-lz-cart-close]');
    if (close) close.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('lz-scroll-lock');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeDrawer();
  }

  function replaceDrawer(html) {
    if (!html) return;
    var wasOpen = drawer && !drawer.hidden;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-lz-cart-drawer]');
    if (!fresh || !drawer) return;
    fresh.hidden = !wasOpen;
    drawer.replaceWith(fresh);
    drawer = fresh;
  }

  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Cart request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function syncCount() {
    return fetch(cfg.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    if (busy) {
      btn.dataset.lzLabel = btn.dataset.lzLabel || btn.innerHTML;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (btn.dataset.lzLabel) btn.innerHTML = btn.dataset.lzLabel;
    }
  }

  function showFormError(form, message) {
    var el = form.querySelector('[data-lz-cart-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function addToCart(form) {
    var idInput = form.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
    var id = idInput ? idInput.value : new FormData(form).get('id');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    showFormError(form, '');
    setBusy(form, true);

    return cartFetch(cfg.cartAdd + '.js', {
      items: [{ id: id, quantity: quantity }],
      sections: [SECTION_ID]
    })
      .then(function (data) {
        if (data.sections && data.sections[SECTION_ID]) replaceDrawer(data.sections[SECTION_ID]);
        return syncCount();
      })
      .then(function () {
        announce('Added to your bag.');
        openDrawer();
      })
      .catch(function (err) {
        showFormError(form, err.message || 'Could not add this item to your bag.');
      })
      .finally(function () {
        setBusy(form, false);
      });
  }

  function changeLine(line, quantity) {
    return cartFetch(cfg.cartChange + '.js', {
      line: line,
      quantity: quantity,
      sections: [SECTION_ID]
    }).then(function (data) {
      if (data.sections && data.sections[SECTION_ID]) replaceDrawer(data.sections[SECTION_ID]);
      updateCartCount(data.item_count);
      announce(quantity === 0 ? 'Item removed from your bag.' : 'Bag updated.');
    });
  }

  /* ---- delegated events ---- */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lz-cart-toggle]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-lz-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var remove = e.target.closest('[data-lz-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.dataset.line, 0);
      return;
    }

    var stepBtn = e.target.closest('[data-lz-qty-plus], [data-lz-qty-minus]');
    if (stepBtn) {
      e.preventDefault();
      var wrap = stepBtn.closest('[data-lz-qty]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min, 10) || 0;
      var current = parseInt(input.value, 10) || min;
      var next = stepBtn.hasAttribute('data-lz-qty-plus') ? current + 1 : Math.max(min, current - 1);
      input.value = next;
      if (input.dataset.line) changeLine(input.dataset.line, next);
    }
  });

  document.addEventListener('submit', function (e) {
    var addForm = e.target.closest('[data-lz-ajax-cart-form]');
    if (addForm) {
      if (e.submitter && e.submitter.closest('.shopify-payment-button')) return; // let dynamic checkout proceed
      e.preventDefault();
      addToCart(addForm);
      return;
    }
    var lineForm = e.target.closest('[data-lz-cart-line-form]');
    if (lineForm) {
      e.preventDefault();
      var input = lineForm.querySelector('[data-lz-cart-qty-input]');
      var qty = input ? parseInt(input.value, 10) || 0 : 0;
      changeLine(lineForm.dataset.line, qty);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-lz-cart-qty-input]');
    if (input) changeLine(input.dataset.line, parseInt(input.value, 10) || 0);
  });

  document.addEventListener('shopify:section:load', function () {
    getDrawer();
  });
})();
